v<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>          
            <v-card pa-0>
              <v-card-text :class="getColor(fm.tingkat_id)" style="z-index:1">
                <h1 class="display-3 ml-4 text-xs-left white--text" style="position:absolute">{{getTingkat(fm.tingkat_id)}}</h1>
                <v-layout column align-center justify-center >
                  <v-progress-circular
                    v-if="imgLoading"
                    :size="200"
                    :width="15"
                    color="info"
                    indeterminate
                    class="mt-4"
                  ></v-progress-circular>            
                  <v-avatar v-if="!imgLoading" size="200" class="mt-4" color="white">                                          
                    <img @click="cropshow=true" :src="imgUrl ? imgUrl : require('@/assets/img/avatar.png')"/>                    
                    <v-btn @click="cropshow=true" fab absolute dark small bottom style="right:0px; bottom:10%; cursor:pointer" class="purple"><v-icon>camera_alt</v-icon></v-btn>
                  </v-avatar>            
                  <h1 class="white--text mb-2">{{fm.nama}}</h1>                        
                </v-layout>  
              </v-card-text>
              <v-stepper :value="fm.status" v-if="showstep" class="mt-0 pt-0">
                <v-stepper-header>
                  <v-stepper-step step="1" :complete="fm.status >= 1">Active</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2" :complete="fm.status >= 2 && isConfirm">Confirm</v-stepper-step>          
                  <v-divider></v-divider>
                  <v-stepper-step step="3" :complete="fm.status >= 3">Bayar</v-stepper-step>          
                  <v-divider></v-divider>
                  <v-stepper-step step="4" :complete="fm.status >= 4">Angket</v-stepper-step>          
                  <v-divider></v-divider>
                  <v-stepper-step step="5" :complete="fm.status >= 5">Cetak</v-stepper-step>         
                  <v-divider></v-divider>
                  <v-stepper-step step="6" :complete="fm.status >= 6">Quran</v-stepper-step>          
                  <v-divider></v-divider>
                  <v-stepper-step step="7" :complete="fm.status >= 7">Pengumuman</v-stepper-step>                    
                </v-stepper-header>
              </v-stepper>
              <v-tabs color="grey lighten-4" show-arrows style="z-index:1">
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab :key="0" :href="'#tab0'">Profil</v-tab>
                <v-tab :key="1" :href="'#tab1'" v-if="fm.status >= 2">Angket</v-tab>
                <v-toolbar dense cad flat>
                  <!--<v-toolbar-title class="title">Form Administrasi</v-toolbar-title>-->
                  <v-spacer></v-spacer>
                  <v-btn @click="print()" round color="pink" dark><v-icon>print</v-icon>&nbsp; print</v-btn>  
                  <v-menu bottom left>
                    <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                    <v-list>
                      <v-list-tile v-bind:to="{path:'/calon/form', query: {id: fm.user.id}}">
                        <v-list-tile-title>Update</v-list-tile-title>
                      </v-list-tile>     
                      <v-list-tile v-bind:to="{path:'/calon'}">
                        <v-list-tile-title>Index</v-list-tile-title>
                      </v-list-tile>          
                      <v-list-tile v-bind:to="{path:'/calon/card'}" v-if="fm.status > 2">
                        <v-list-tile-title>Card</v-list-tile-title>
                      </v-list-tile>          
                    </v-list>
                  </v-menu>  
                </v-toolbar>
                <v-tabs-items>
                  <v-tab-item :key="0" :value="'tab0'">
                    <v-card flat>                
                      <v-card-text>                
                        <v-container grid-list-lg class="pa-0 ma-0">
                          <h3 class="text-xs-left mt-0">Form Signin</h3>          
                            <v-layout row wrap> 
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile>
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>phone</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Phone</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.user.phone}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile class="px-0">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>person</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>username</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.user.username}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>                             
                            </v-layout>  
                          <h3 class="text-xs-left mt-1">Data Siswa</h3>
                            <v-layout row wrap>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile class="px-0">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>brightness_low</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>tingkat</v-list-tile-sub-title>
                                    <v-list-tile-title>{{getTingkat(fm.tingkat_id)}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile class="px-0"  v-if="fm.tingkat_id === 3">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>brightness_high</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>jurusan</v-list-tile-sub-title>
                                    <v-list-tile-title>{{getJurusan(fm.jurusan_id)}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex lg4 md6 sm6 xs12>
                                <v-list-tile class="px-0">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>person</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>nama siswa</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.nama}}</v-list-tile-title>                                   
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex> 
                              <v-flex lg4 md6 sm6 xs12>
                                <v-list-tile class="px-0">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>child_care</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>lahir</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.lahir_tempat}}, {{fm.lahir_tanggalV}}</v-list-tile-title>                                   
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex> 
                              <v-flex lg4 md6 sm6 xs12>
                                <v-list-tile class="px-0">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>accessibility</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>gender</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.gender === 1? 'Laki-laki':'Perempuan'}}</v-list-tile-title>                                   
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex> 
                              <v-flex lg12 md12 sm12 xs12>
                                <v-list three-line>
                                  <v-list-tile class="px-0">
                                    <v-list-tile-action>
                                      <v-icon color="green darken-3" large>home</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title>alamat</v-list-tile-sub-title>
                                      <v-list-tile-title>{{fm.alamat}}</v-list-tile-title>                                   
                                      <v-list-tile-title>
                                        <span v-if="kelurahans.find(x=>x.id===fm.kelurahan_id)">kel. {{kelurahans.find(x=>x.id===fm.kelurahan_id).nama}}, </span>
                                        <span v-if="kecamatans.find(x=>x.id===fm.kecamatan_id)">kec. {{kecamatans.find(x=>x.id===fm.kecamatan_id).nama}}, </span>
                                        <span v-if="kotas.find(x=>x.id===fm.kota_id)">{{kotas.find(x=>x.id===fm.kota_id).nama}}, </span>
                                        <span v-if="provinsis.find(x=>x.id===fm.provinsi_id)">prov. {{provinsis.find(x=>x.id===fm.provinsi_id).nama}}</span>                                        
                                        
                                      </v-list-tile-title>                                   
                                    </v-list-tile-content>                                  
                                  </v-list-tile> 
                                </v-list>
                              </v-flex>                                                             
                            </v-layout>
                            <h3 class="text-xs-left">Sekolah Asal</h3>          
                            <v-layout row wrap style="border:0px solid #eee;">                                   
                              <v-flex lg8 md8 sm12 xs12>
                                <v-list three-line style="margin-top:-10px">
                                  <v-list-tile class="px-0">
                                    <v-list-tile-action>
                                      <v-icon color="green darken-3" large>domain</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                      <v-list-tile-sub-title>Nama Sekolah</v-list-tile-sub-title>
                                      <v-list-tile-title>{{fm.sekolah_nama}} ({{fm.sekolah_npsn}})</v-list-tile-title>                                   
                                      <v-list-tile-title>                                        
                                        <span v-if="sekolahKecamatans.find(x=>x.id===fm.sekolah_kecamatan_id)">kec. {{sekolahKecamatans.find(x=>x.id===fm.sekolah_kecamatan_id).nama}}, </span>
                                        <span v-if="sekolahKotas.find(x=>x.id===fm.sekolah_kota_id)">{{sekolahKotas.find(x=>x.id===fm.sekolah_kota_id).nama}}, </span>                                        
                                        <span v-if="provinsis.find(x=>x.id===fm.sekolah_provinsi_id)">prov. {{provinsis.find(x=>x.id===fm.sekolah_provinsi_id).nama}}</span>                                        
                                      </v-list-tile-title>                                   
                                    </v-list-tile-content>                                  
                                  </v-list-tile> 
                                </v-list>
                              </v-flex> 
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile class="px-0">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>fingerprint</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>NIS</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.sekolah_nis?fm.sekolah_nis:'-'}}</v-list-tile-title>                                   
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                            </v-layout>
                          <h3 class="text-xs-left mt-4">Data Orang Tua</h3>          
                            <v-layout row wrap  style="border:0px solid #eee;"> 
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile>
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>email</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Email</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.email}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile>
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>phone</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Telepon</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.telepon}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile>
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>phone</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Whatsapp</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.whatsapp}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile class="mt-2">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>face</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Nama Ayah</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.ayah_nama}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                                <v-list-tile class="mt-3">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>work</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Pekerjaan</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.ayah_pekerjaan}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                                <v-list-tile class="mt-3">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>account_balance_wallet</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Penghasilan</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.ayah_penghasilan}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>                              
                              <v-flex lg4 md4 sm6 xs12>
                                <v-list-tile>
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>pregnant_woman</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Nama Ibu</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.ibu_nama}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                                <v-list-tile class="mt-3">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>work</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Pekerjaan</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.ibu_pekerjaan}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                                <v-list-tile class="mt-3">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>account_balance_wallet</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Penghasilan</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.ibu_penghasilan}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile> 
                              </v-flex>
                            </v-layout>  
                            <v-layout row wrap>  
                              <v-flex lg4 md6 sm6 xs12>
                                <v-list-tile class="mt-3">
                                  <v-list-tile-action>
                                    <v-icon color="green darken-3" large>shopping_basket</v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-sub-title>Pengeluaran Keluarga/Bulan*</v-list-tile-sub-title>
                                    <v-list-tile-title>{{fm.pengeluaran}}</v-list-tile-title>                                    
                                  </v-list-tile-content>                                  
                                </v-list-tile>                                 
                              </v-flex>
                            </v-layout>          
                          </v-container>
                          <crop-upload style="width:100%;" field="img"
                            @crop-success="cropSuccess"        
                              :width="300"
                              :height="300"         
                              lang-type="en"
                              :value.sync="cropshow"
                              v-model="cropshow"                
                              img-format="png">            
                          </crop-upload> 
                        </v-card-text>
                        <v-card-text>
                          <h3 class="text-xs-left mt-4">Prestasi Siswa (jika ada)</h3>          
                          <div class="v-table__overflow tabular">
                            <v-data-table
                              v-bind:headers="prestasi.headers"
                              v-bind:items="fm.calonPrestasis"
                              hide-actions class="elevation-1 tabular" 
                            >
                            <template slot="items" slot-scope="props" >
                              <td style="width:1%">{{props.index+1}}</td>
                              <td style="width:180px"><span v-if="prestasi.types.find(x=>x.id===props.item.type)">
                                  {{prestasi.types.find(x=>x.id===props.item.type).name}}</span>
                              </td>
                              <td style="width:100px">{{props.item.nama}}</td> 
                              <td>{{props.item.description}}</td>
                              <td style="width:150px">                                
                                <a :href="props.item.image" target="_blank"><img :src="props.item.thumb" style="height:40px" /></a>                         
                              </td>                                 
                            </template>  
                          </v-data-table>
                        </div>          
                      </v-card-text>       
                    </v-card>
                  </v-tab-item>
                  <v-tab-item :key="1" :value="'tab1'">
                    <v-card flat>
                      <v-card-text style="min-height: 700px">
                        <p>Pilih jawaban yang paling sesuai dengan kondisi dan fikiran Bapak/Ibuk</p>
                        <ol style="margin-left:-10px">
                          <li v-for="(quetion,i) in fm.quetionnaires" class="mb-3" :key="i">          
                            {{quetion.question}}
                            <template v-if="quetion.type === 1">
                              <v-radio-group v-model="quetion.answer_id" hide-details class="mt-0">
                                <v-radio :disabled="true" v-for="(opt,n) in quetion.option" :key="n"
                                  :label="opt.key+'. '+opt.value" :value="parseInt(opt.id)"
                                ></v-radio>
                              </v-radio-group>
                            </template>
                            <template v-else-if="quetion.type === 2">
                              <v-checkbox :disabled="true" v-for="(opt,n) in quetion.option" v-model="quetion.answer_jsonid[n]" :key="n" class="mt-1" :label="opt.key+'. '+opt.value" :value="opt.id" hide-details></v-checkbox>            
                            </template>
                            <template v-else-if="quetion.type === 3">
                              <v-text-field :disabled="true" v-for="(opt,n) in quetion.option" v-model="quetion.answer_jsonvalue[n]" :key="n" type="text" :label="opt.key" small hide-details style="max-width:400px;margin-bottom:4px;" >
                                <span :set="quetion.answer_jsonkey[n] = opt.key"></span>
                              </v-text-field>
                            </template>

                            <!--<template v-if="angket.type === 1">
                              <v-radio-group v-model="fm.calonQuetionnaire[i].answer_key" hide-details class="mt-0">
                                <v-radio v-for="(opt,n) in angket.option" v-if="opt.no === fm.calonQuetionnaire[i].answer_key" :key="n"
                                  :label="opt.no+'. '+opt.answer" :value="opt.no"
                                ></v-radio>
                              </v-radio-group>
                            </template>
                            <template v-else-if="angket.type === 2">
                              <v-checkbox v-for="(opt,n) in angket.option"  v-if="fm.calonQuetionnaire[i].answer_json && fm.calonQuetionnaire[i].answer_json.includes(opt.no)" :key="n" v-model="fm.calonQuetionnaire[i].answer_json" class="mt-1" :label="opt.no+'. '+opt.answer" :value="opt.no" hide-details></v-checkbox>            
                            </template>
                            <template v-else-if="angket.type === 3">
                              <v-text-field v-for="(opt,n) in angket.option" v-if="fm.calonQuetionnaire[i].answer_json[opt.no]" :disabled="true" :key="n" type="text" v-model="fm.calonQuetionnaire[i].answer_json[opt.no]" :label="opt.no" small hide-details style="max-width:300px;margin-bottom:4px;"></v-text-field>
                            </template>-->
                          </li>
                        </ol>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>  
                 
                </v-tabs-items>
              </v-tabs>                     
            </v-card>
            <v-card>
              <v-card-text class="printcontent2">
                <h3 class="text-xs-center">Biodata Calon Siswa</h3>
                <hr/>
                <table style="width:100%; font-size:12px">
                  <tbody>
                    <tr><td colspan="6"><strong>Account</strong></td></tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">phone</v-icon></td>
                      <td style="width:30%"><small>phone</small><br/>{{fm.user.phone}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">person</v-icon></td>
                      <td style="width:30%"><small>phone</small><br/>{{fm.user.username}}</td>
                      <td colspan="2"></td>
                    </tr>
                    <tr><td colspan="6" class="pt-3"><strong>Data Siswa</strong></td></tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">brightness_low</v-icon></td>
                      <td style="width:30%"><small>tingkat</small><br/>{{getTingkat(fm.tingkat_id)}}</td>
                      <td style="width:40px"><template v-if="fm.tingkat_id === 3"><v-icon color="green darken-3">brightness_high</v-icon></template></td>
                      <td style="width:30%"><template v-if="fm.tingkat_id === 3"><small>jurusan</small><br/>{{getJurusan(fm.jurusan_id)}}</template></td>
                      <td colspan="2"></td>                                                    
                    </tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">person</v-icon></td>
                      <td style="width:30%"><small>nama siswa</small><br/>{{fm.nama}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">child_care</v-icon></td>
                      <td style="width:30%"><small>lahir</small><br/>{{fm.lahir_tempat}}, {{fm.lahir_tanggalV}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">accessibility</v-icon></td>
                      <td style="width:30%"><small>gender</small><br/>{{fm.gender === 1? 'Laki-laki':'Perempuan'}}</td>                                            
                    </tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">home</v-icon></td>
                      <td colspan="5"><small>alamat</small>: {{fm.alamat}}<br/>
                        <span v-if="kelurahans.find(x=>x.id===fm.kelurahan_id)">kel. {{kelurahans.find(x=>x.id===fm.kelurahan_id).nama}}, </span>
                        <span v-if="kecamatans.find(x=>x.id===fm.kecamatan_id)">kec. {{kecamatans.find(x=>x.id===fm.kecamatan_id).nama}}, </span>
                        <span v-if="kotas.find(x=>x.id===fm.kota_id)">{{kotas.find(x=>x.id===fm.kota_id).nama}}, </span>
                        <span v-if="provinsis.find(x=>x.id===fm.provinsi_id)">prov. {{provinsis.find(x=>x.id===fm.provinsi_id).nama}}</span>                                        
                      </td>                      
                    </tr>
                    <tr><td colspan="6" class="pt-3"><strong>Sekolah Asal</strong></td></tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">domain</v-icon></td>
                      <td colspan="3"><small>nama sekolah</small><br/> {{fm.sekolah_nama}}<br/>
                        <span v-if="sekolahKecamatans.find(x=>x.id===fm.sekolah_kecamatan_id)">kec. {{sekolahKecamatans.find(x=>x.id===fm.sekolah_kecamatan_id).nama}}, </span>
                        <span v-if="sekolahKotas.find(x=>x.id===fm.sekolah_kota_id)">{{sekolahKotas.find(x=>x.id===fm.sekolah_kota_id).nama}}, </span>                                        
                        <span v-if="provinsis.find(x=>x.id===fm.sekolah_provinsi_id)">prov. {{provinsis.find(x=>x.id===fm.sekolah_provinsi_id).nama}}</span>                                        
                      </td>
                      <td style="width:40px"><v-icon color="green darken-3">fingerprint</v-icon></td>
                      <td style="width:30%"><small>NIS</small><br/>{{fm.sekolah_nis?fm.sekolah_nis:'-'}}</td>                                                                              
                    </tr>
                    <tr><td colspan="6" class="pt-3"><strong>Data Orang Tua</strong></td></tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">email</v-icon></td>
                      <td style="width:30%"><small>email</small><br/>{{fm.email}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">phone</v-icon></td>
                      <td style="width:30%"><small>telepon</small><br/>{{fm.telepon}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">phone</v-icon></td>
                      <td style="width:30%"><small>whatsapp</small><br/>{{fm.whatsapp}}</td>                                            
                    </tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">face</v-icon></td>
                      <td style="width:30%"><small>nama ayah</small><br/>{{fm.ayah_nama}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">pregnant_woman</v-icon></td>
                      <td style="width:30%"><small>nama ibu</small><br/>{{fm.ibu_nama}}</td>
                      <td colspan="2"></td>
                    </tr>
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">work</v-icon></td>
                      <td style="width:30%"><small>pekerjaan ayah</small><br/>{{fm.ayah_pekerjaan}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">work</v-icon></td>
                      <td style="width:30%"><small>pekerjaan ibu</small><br/>{{fm.ibu_pekerjaan}}</td>
                      <td colspan="2"></td>
                    </tr> 
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">account_balance_wallet</v-icon></td>
                      <td style="width:30%"><small>penghasilan ayah</small><br/>{{fm.ayah_penghasilan}}</td>
                      <td style="width:40px"><v-icon color="green darken-3">account_balance_wallet</v-icon></td>
                      <td style="width:30%"><small>penghasilan ibu</small><br/>{{fm.ibu_penghasilan}}</td>
                      <td colspan="2"></td>
                    </tr> 
                    <tr>
                      <td style="width:40px"><v-icon color="green darken-3">shopping_basket</v-icon></td>
                      <td style="width:30%" colspan="5"><small>pengeluaran keluarga perbulan</small><br/>{{fm.pengeluaran}}</td>                      
                    </tr>
                    <tr>
                      <td colspan="6">
                        <h3 class="text-xs-left mt-4">Prestasi Siswa (jika ada)</h3>          
                          <div class="v-table__overflow tabular">
                            <v-data-table
                              v-bind:headers="prestasi.headers2"
                              v-bind:items="fm.calonPrestasis"
                              hide-actions class="elevation-1 tabular" 
                            >
                            <template slot="items" slot-scope="props" >
                              <td style="width:1%">{{props.index+1}}</td>
                              <td style="width:180px"><span v-if="prestasi.types.find(x=>x.id===props.item.type)">
                                  {{prestasi.types.find(x=>x.id===props.item.type).name}}</span>
                              </td>
                              <td style="width:100px">{{props.item.nama}}</td> 
                              <td>{{props.item.description}}</td>                                                             
                            </template>  
                          </v-data-table>
                        </div>          
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-card-text>
            </v-card>
          </v-flex>                   
        </v-layout>        
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import CropUpload from 'vue-image-crop-upload'; 
import KartuUjian from './card';
import Model  from '@/apps/admin/models/Calon';    
import moment from 'moment';

var model = new Model();

export default {
  components : {CropUpload,KartuUjian},
  $_veeValidate: {
      validator: 'new'
  },    
  data: () => ({      
      showstep:false,
      showpass:false,
      isEditing:true,
      isUpdate:false,                
      cropshow: false,
      imgUrl : null,
      imgLoading : false,
      saveLoading : false,
      completeLoading : false, 
      prestasi  : {
          types: [
            {id:1, name:'OSN'},
            {id:2, name:'KSM'},
            {id:3, name:'MTQ'},
            {id:4, name:'MHQ'},
            {id:5, name:'Hafidz > 3 juz'},
            {id:6, name:'Lainnya'}
          ],
          juaras:['1','2','3','lainnya'],
          headers: [            
            { text: 'No', value:'no'},
            { text: 'Kategori', value: 'type'},
            { text: 'Juara', value: 'nama'},
            { text: 'Deskripsi', value: 'description'},              
            { text: 'Foto Sertifikat', value:''},                          
          ],   
          headers2: [            
            { text: 'No', value:'no'},
            { text: 'Kategori', value: 'type'},
            { text: 'Juara', value: 'nama'},
            { text: 'Deskripsi', value: 'description'},                          
          ],   
      }, 
      fm : {
        user : {
            username : null,
            phone : null,
            password : null,
            status : 10,
        },
        user_id : null,
        tingkat_id : null,
        jurusan_id : null,
        nama : null,
        gender : null,
        lahir_tempat : null,
        lahir_tanggal : null,
        lahir_tanggalV : null,
        alamat : null,
        kelurahan_id : null,
        kecamatan_id : null,
        kota_id : null,
        provinsi_id : null,
        prestasi_osn : null,
        prestasi_mtq : null,
        prestasi_hafidz : null,
        prestasi_other : null,
        sekolah_nis : null,
        sekolah_nama : null,
        sekolah_provinsi_id : null,
        sekolah_kota_id : null,
        sekolah_kecamatan_id : null,
        telepon : null,
        whatsapp : null,
        email : null,
        ayah_nama : null,
        ayah_pekerjaan : null, 
        ayah_jabatan : null,
        ayah_penghasilan : null,
        ibu_nama : null,
        ibu_pekerjaan : null, 
        ibu_jabatan : null,
        ibu_penghasilan : null,
        calonPrestasis : [],
        quetionnaires : [],
        calonQuetionnaire : [],
      },      
      provinsis : [],
      provinsiLoading : false,
      provinsiSearch : null,
      kotaLoading : false,
      kotas : [],   
      kotaSearch : null,
      kecamatanLoading : false,
      kecamatans : [],
      kecamatanSearch : null,
      kelurahanLoading : false,
      kelurahans : [],
      kelurahanSearch : null,
      sekolahProvinsiLoading : false,
      sekolahProvinsis : [],
      sekolahProvinsiSearch : null,
      sekolahKotaLoading : false,
      sekolahKotas : [],
      sekolahKotaSearch : null,
      sekolahKecamatanLoading : false,
      sekolahKecamatans : [],
      sekolahKecamatanSearch : null,
      pekerjaans : ["tidak bekerja", "nelayan", "petani-peternak","guru-dosen","PNS","TNI-POLRI","BUMN","wiraswasta","karyawan","buruh","pensiunan"],
      penghasilans : ["0 sd 2jt","2jt-4jt", "4jt-6jt", "6jt-8jt", "8jt-10jt", "10jt-15jt", "15jt-keatas"],      
      
  }),
 // created () {this.getParents()},    
  computed :{
    isConfirm(){
        if(this.fm.nama === null || this.fm.tingkat_id === null || this.fm.gender === null ||
            this.fm.lahir_tempat === null || this.fm.lahir_tanggal === null || this.fm.alamat === null ||
            this.fm.ayah_nama === null || this.fm.ayah_pekerjaan === null || this.fm.ayah_penghasilan === null || this.fm.pengeluaran === null ||
            this.fm.ibu_nama === null || this.fm.ibu_pekerjaan === null || this.fm.ibu_penghasilan === null ||
            this.fm.telepon === null){          
          return false;
        }
        return true;
    },
  },
  mounted () {
    model.tingkats().then(data=>{this.tingkats = data});
    this.$watch(['fm','lahir_tanggal'].join('.'), (val)=>{ if(val){
      //this.$refs.birthdate.save(val);
      this.fm.lahir_tanggalV = this.$moment(val).format('DD-MM-YYYY');
    }});     
    
    this.init(); 
  }, 
  methods : {
    print(){
      print();
    },
    
    init(){
      if(this.$route.query.id){        
        this.isUpdate   = true;
        model.one({id : this.$route.query.id }).then(data => { 
          if(data.user){
            this.fm.user_id = data.user.id; this.fm.telepon = data.user.phone;      
          }
          Object.assign(this.fm, data === null ? {}:data);
          this.fm.gender = parseInt(this.fm.gender);
          this.fm.tingkat_id = parseInt(this.fm.tingkat_id);
          if(this.fm.user_id)this.getavatar();
          
          this.fm.calonPrestasis.forEach((item)=>{
            item.thumb = this.imageUrl('certificate-thumb', item.id);
            item.image = this.imageUrl('certificate-image', item.id);
          });
          
          this.fm.quetionnaires.forEach((item,i)=>{
            let answer_jsonv = [];
            if(item.type === 3){
              answer_jsonv = {};
              item.option.forEach(opt=>{
                answer_jsonv[opt.no] = null;
              });             
            }
            if(item.calonQuetionnaire){
              if(item.type === 3 && !item.calonQuetionnaire.answer_json){
                item.calonQuetionnaire.answer_json = answer_jsonv;
              }
              this.fm.calonQuetionnaire.push(item.calonQuetionnaire);
            } else {
              this.fm.calonQuetionnaire.push({quetionnaire_id:item.id,calon_id:this.fm.id,answer_key:null,answer_value:null,answer_json:answer_jsonv});
            }
          });          
          
          this.showstep = true;
          //this.fm.quetionnaires = data;
        });                                               
      } else {
        this.newPrestasi();
      }            
      this.setProvinsis();
      this.$watch(['fm','provinsi_id'].join('.'), (id)=>{this.kotaLoading = true;
        model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.kotas = data; this.kotaLoading = false;});
      });
      this.$watch(['fm','sekolah_provinsi_id'].join('.'), (id)=>{this.sekolahKotaLoading = true;
        model.kotas({'KotaSearch[provinsi_id]':id}).then(data=>{this.sekolahKotas = data; this.sekolahKotaLoading = false;});
      });
      this.$watch(['fm','kota_id'].join('.'), (id)=>{this.kecamatanLoading = true;
        model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.kecamatans = data; this.kecamatanLoading = false;});
      });
      this.$watch(['fm','sekolah_kota_id'].join('.'), (id)=>{this.sekolahKecamatanLoading = true;
        model.kecamatans({'KecamatanSearch[kota_id]':id}).then(data=>{this.sekolahKecamatans = data; this.sekolahKecamatanLoading = false;});
      });
      this.$watch(['fm','kecamatan_id'].join('.'), (id)=>{this.kelurahanLoading = true;
        model.kelurahans({'KelurahanSearch[kecamatan_id]':id}).then(data=>{this.kelurahans = data; this.kelurahanLoading = false;});        
      });       
    },
    
    imageUrl(route, id){ return this.$config.file + route +'?reff_id='+id+'&'+(0|Math.random()*9e6).toString(36);},
    
    setProvinsis(){
      this.provinsiLoading = true; this.sekolahProvinsiLoading = true;
      model.provinsis().then(data=>{
        this.provinsis = data; this.sekolahProvinsis = data;
        this.provinsiLoading = false; this.sekolahProvinsiLoading = false;
      });
    },
    
    setFile(event, props){      
      props.item.file = event.target.files[0];
    },
    
    newPrestasi(){
      this.fm.calonPrestasis.push({type : null, description: null, file:null});
    },
    
    delPrestasi(props){            
      this.fm.calonPrestasis.splice(props.index, 1);   
      //this.detail.splice(props.index, 1);   
    },
    
    getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; case 7:return 'light-green'; default:return 'black';}
    },
    
    getTingkat(tingkat){
      switch(tingkat){case 1:return 'SD'; case 2: return 'SMP'; case 3:return 'MA'; default:return '';}
    },
    
    getJurusan(jurusan){
      switch(jurusan){case 4:return 'IPA'; case 5: return 'IPS'; case 6:return 'AGAMA'; default:return '';}
    },

    async save(isUpdate = false) {  
        var FormData = require('form-data');        
        let fmdata   = new FormData();
        let formData = this.convertToFormData(this.fm, fmdata, null);
        var res = isUpdate ? await model.update(formData): await model.create(formData);                
        if(res.status === 200){   
            this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
            if(!isUpdate){
              this.$router.push({path:'/signup/calon/form', query:{id:res.data.user_id}});                    
            } 
        } else {
            var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
            var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
            if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
            this.$swal({type: 'error', title: title, text: text});                    
        }                   
    },
    
    completeAdministrasi(){
      this.$validator.validateAll();
      if( !this.errors.any() ) { 
        this.loading=true;
        var FormData = require('form-data');        
        let fmdata   = new FormData();
        let formData = this.convertToFormData(this.fm, fmdata, null);
        model.completeAdministrasi(formData).then(res=>{
          if(res.status === 200){  
              this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
              this.$router.go(-1);
              //this.$router.push({path:'/user', query:{id:res.data.id}});                    
          } else {
              var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
              var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
              if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
              this.$swal({type: 'error', title: title, text: text});                    
          }
          this.loading=false;
        });          
      }        
    },

    convertToFormData(data, formData, parentKey) {
        if(data === null || data === undefined) return null;
        formData = formData || new FormData();
        if (typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
          Object.keys(data).forEach(key => 
            //this.convertToFormData(data[key], formData, (!parentKey ? key : (data[key] instanceof File ? parentKey : `${parentKey}[${key}]`)))
            this.convertToFormData(data[key], formData, (!parentKey ? key : (data[key] instanceof File ? `${parentKey}[${key}]` : `${parentKey}[${key}]`)))
          );
        } else {
          formData.append(parentKey, data);
        }
        return formData;
    },
    
    validate(data){
        data.forEach( (item) => {
            this.$validator.errors.add({field : item.field,msg : item.message});
        });
    },           

    customFilter (item, queryText, itemText) {
        const textOne = item.nama.toLowerCase()
        //const textTwo = item.abbr.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1; 
    },           
      
    cropSuccess(imgDataUrl, field){
      //console.log('-------- crop success --------');
      //this.imgDataUrl = imgDataUrl;

      var block = imgDataUrl.split(";");
      var contentType = block[0].split(":")[1];// In this case "image/gif"
      var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
      var blob = this.b64toBlob(realData, contentType);

      var FormData = require('form-data');
      let formData = new FormData();

      formData.append('image', blob, 'userprofile');
      formData.append('reff_id', this.fm.user_id);
      formData.append('reff_type', 1);        

      this.imgLoading = true;
      model.setavatar(formData).then(res=>{
        this.getavatar();            
      });
    }, 
    
    getavatar(){
      this.imgLoading  = true;
      model.getavatar({reff_id:this.fm.user_id}).then(res=>{
        if(res.data){
          this.imgUrl      = res.data;          
        }
        this.imgLoading  = false;
      });
    },
    
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },  
  }
}
</script>
<style>
.printcontent2 * {visibility: hidden; color:#000;}  
.printcontent2 {position : fixed; top:0px; left:0px; z-index: -1}  

@media print
{
    body * {visibility:hidden;}
    .printcontent2 * {visibility : visible;}
    .printcontent2 {position : fixed; top:0px; left:0px; height:300px}
}
</style>